import { SwitchProductModule } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../../components/ModuleProvider';
export const useValidateProductId = () => {
  const module = useCurrentModule();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    canPurchase,
    isLoading: isProductAvailabilityLoading
  } = SwitchProductModule.SDK.hooks.useProductAvailability({
    productId: selectedProductId || ''
  });
  return {
    valid: canPurchase,
    isLoading: isProductAvailabilityLoading
  };
};
//# sourceMappingURL=useValidateProductId.js.map